


































































































































import {Component, Mixins} from 'vue-property-decorator';
import {IContentSection} from '@/components/types';
import ContentSection from '@/components/ContentSection.vue';
import Input from '@/components/form/Input.vue';
import Select from '@/components/form/Select.vue';
import Checkbox from '@/components/form/Checkbox.vue';
import Textarea from '@/components/form/Textarea.vue';
import apiMixin, {ApiException} from '@/mixins/apiMixin';
import FormDataType from '@/store/types/FormDataType';
import TranslatedRouter from '@/mixins/TranslatedRouter';

@Component({
	components: {
		'v-content-section': ContentSection,
		'v-input': Input,
		'v-select': Select,
		'v-checkbox': Checkbox,
		'v-textarea': Textarea,
	}
})
export default class ContactForm extends Mixins(apiMixin, TranslatedRouter) {

	isSend: boolean = false;
	isLoading: boolean = false;

	$refs: {
		nameInput: Input,
		emailInput: Input,
		topicInput: Select,
		agreeInput: Checkbox,
		messageInput: Textarea,
	}

	get absolutePath() {
		return serverVariables.httpRequest.baseUrl;
	}
	get getPdfPath() {
		return this.absolutePath + 'dist/pdf/';
	}
	get form(): FormDataType {
		return {
			name: '',
			email: '',
			phone: '',
			topic: '',
			agree: false,
			message: '',
			options: [
				{
					label: this.$t('contactForm.options.question_topic.label') as string,
					value: null,
				},
				{
					label: this.$t('contactForm.options.new_user.label') as string,
					value: this.$t('contactForm.options.new_user.label') as string,
				},
				{
					label: this.$t('contactForm.options.my_account.label') as string,
					value: this.$t('contactForm.options.my_account.label') as string,
				},
				{
					label: this.$t('contactForm.options.report_bug.label') as string,
					value: this.$t('contactForm.options.report_bug.label') as string,
				},
				{
					label: this.$t('contactForm.options.feedback.label') as string,
					value: this.$t('contactForm.options.feedback.label') as string,
				},
				{
					label: this.$t('contactForm.options.media.label') as string,
					value: this.$t('contactForm.options.media.label') as string,
				},
				{
					label: this.$t('contactForm.options.partnership.label') as string,
					value: this.$t('contactForm.options.partnership.label') as string,
				},
				{
					label: this.$t('contactForm.options.other.label') as string,
					value: this.$t('contactForm.options.other.label') as string,
				},
			],
			token: null
		};
	}

	get content(): IContentSection {
		return {
			headline: this.$t('contactForm.headline') as string,
			perex: this.$t('contactForm.perex') as string
		}
	}

	get isDisabledAll(): boolean {
		return this.isLoading;
	}

	async handleSubmit(): Promise<void> {


		if (this.fieldInvalid()) {
			return;
		}

		try {
			this.isLoading = true;

			const token = await this.recaptcha.execute();

			const canSubmit = await this.RecaptchaP({token: token});

			if (canSubmit.data.status === false) {
				return;
			}

			const params: FormDataType = {...this.form, token}
			delete params.agree;
			delete params.options;
			await this.ContactP(params);
			this.isLoading = false;
			this.isSend = true;
		} catch (error) {
			this.catchException(error, (exception: ApiException) => {
				console.log(exception.message)
			});
		}
	}
}
